

<template>
  <section class="evento-lux">
    <!-- ===== TARJETA: RECEPCIÓN ===== -->
    <article ref="card2" class="card" aria-label="Recepción">
      <div class="card-inner">
        <img class="icono" src="@/assets/cel.png" alt="" />
        <h3 class="titulo-script">Recepción</h3>
        <p class="hora">6:30 PM</p>
        <p class="lugar">Illusion Reception Hall
</p>
        <p class="direccion">198 Uvalde Rd, Houston, Texas.</p>
        
        <a
          ref="btn2"
          class="btn-rosa"
          href="https://maps.app.goo.gl/wKDb1SVQRfLef6My8"
          target="_blank"
          rel="noopener"
        >
          ¿Cómo llegar?
          <span class="sheen" aria-hidden="true"></span>
        </a>
      </div>
    </article>
  </section>

  
</template>

<script>
import { ref, onMounted } from 'vue'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
gsap.registerPlugin(ScrollTrigger)

export default {
  name: 'EventoSectionLuxuryScroll',
  setup() {
    const card2 = ref(null)
    const btn2 = ref(null)

    onMounted(() => {
      const cardEl = card2.value
      const btnEl = btn2.value

      const $ = gsap.utils.selector(cardEl)
      const icono  = $('.icono')
      const titulo = $('.titulo-script')
      const hora   = $('.hora')
      const lugar  = $('.lugar')
      const dir    = $('.direccion')

      // Timeline de entrada moderna, fluida y escalonada basada en viewport (sin scrub pesado)
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: cardEl,
          start: 'top 82%', // Se dispara de forma natural al asomarse por la pantalla
          toggleActions: 'play none none none'
        },
        defaults: { ease: 'power3.out' }
      })

      // Animación ultra elegante con desenfoque suave tipo "fade-in cinematic"
      tl.fromTo(cardEl, 
          { opacity: 0, y: 35, scale: 0.96, filter: 'blur(8px)' }, 
          { opacity: 1, y: 0, scale: 1, filter: 'blur(0px)', duration: 0.9 }
        )
        .fromTo(icono,  
          { opacity: 0, y: 20, scale: 0.8 }, 
          { opacity: 1, y: 0, scale: 1, duration: 0.7, ease: 'back.out(1.7)' }, 
          '-=0.6'
        )
        .fromTo(titulo, 
          { opacity: 0, y: 25, filter: 'blur(4px)' }, 
          { opacity: 1, y: 0, filter: 'blur(0px)', duration: 0.8 }, 
          '-=0.5'
        )
        .fromTo(hora,   
          { opacity: 0, y: 15 }, 
          { opacity: 1, y: 0, duration: 0.6 }, 
          '-=0.5'
        )
        .fromTo(lugar,  
          { opacity: 0, y: 15 }, 
          { opacity: 1, y: 0, duration: 0.6 }, 
          '-=0.45'
        )
        .fromTo(dir,    
          { opacity: 0, y: 15 }, 
          { opacity: 1, y: 0, duration: 0.6 }, 
          '-=0.4'
        )
        .fromTo(btnEl,  
          { opacity: 0, y: 20, scale: 0.92 }, 
          { opacity: 1, y: 0, scale: 1, duration: 0.7, ease: 'back.out(1.5)' }, 
          '-=0.35'
        )

      // Efecto brillo (sheen) dinámico y elegante al entrar al botón
      ScrollTrigger.create({
        trigger: cardEl,
        start: 'top 80%',
        once: true,
        onEnter: () => {
          const shine = btnEl.querySelector('.sheen')
          if (!shine) return
          gsap.fromTo(
            shine,
            { xPercent: -120, opacity: 0 },
            { xPercent: 150, opacity: 1, duration: 0.8, ease: 'power2.out', delay: 0.3 }
          )
        }
      })
    })

    return { card2, btn2 }
  }
}
</script>

<style scoped>
/* ==================== BASE ELEGANTE ==================== */
:root {
  --rosa: #f4c6cc;
  --rosa-alt: #f0c3e3;
  --tinta: #141414;
  --gris: #5a5858;
  --borde: #e8e4e4;
}

.evento-lux {
  min-height: 100%;
  margin-top:-15px;
  padding: 35px 18px 0px;
  background:
   #f3f7fd;
  place-items: center;
}

/* ==================== TARJETA PROTAGONISTA ==================== */
.card {
  width: min(460px, 92vw);
  border: 1px solid var(--borde);
  border-radius: 20px;
  padding: 36px 24px 38px;
  text-align: center;
  background: #f3f7fd;
  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.04);
  will-change: transform, opacity, filter;
}

.card-inner {
  display: flex;
  flex-direction: column;
  align-items: center;
}

/* Icono discreto */
.icono {
  width: 108px;
  height: auto;
  display: block;
  margin: 0 auto 14px;
  filter: drop-shadow(0 2px 4px rgba(0,0,0,.06));
  opacity: .95;
  will-change: transform, opacity;
}

/* Tipos */
.titulo-script {
  font-family: 'britishgruesa', cursive;
  font-weight: 400;
  font-size: 60px;
  color: var(--tinta);
  letter-spacing: .4px;
  margin: 4px 0 10px;
  will-change: transform, opacity, filter;
}
.hora {
  font-family: 'fa', sans-serif;
  font-size: 26px;
  color: var(--tinta);
  margin: 0 0 8px;
  will-change: transform, opacity;
}
.lugar {
  font-family: 'padres', serif;
  font-size: 23px;
  color: #000;
  font-weight: 500;
  margin: 0 0 10px;
  letter-spacing: .14em;
  will-change: transform, opacity;
}
.direccion {
  font-family: 'padres', serif;
  font-style: italic;
  color: var(--gris);
  font-size: 15px;
  line-height: 1.5;
  margin: 0 auto 22px;
  max-width: 90%;
  will-change: transform, opacity;
}

/* ==================== BOTÓN ROSA ==================== */
.btn-rosa {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 13px 24px;
  border-radius: 14px;
background: url('@/assets/dorado.jpg') center center / cover no-repeat;  color: #0a0744;
  text-decoration: none;
  font-family: 'padres', sans-serif;
  font-weight: 800;
  font-size: 14px;
  line-height: 1;
  box-shadow: 0 8px 20px rgba(0,0,0,.1), inset 0 1px 0 rgba(255,255,255,.8);
  transition: transform .2s ease, box-shadow .2s ease, filter .2s ease;
  border: 1px solid rgba(0,0,0,.06);
  z-index: 0;
  will-change: transform, opacity, scale;
}
.btn-rosa:hover {
  transform: translateY(-2px);
  box-shadow: 0 12px 24px rgba(0,0,0,.15), inset 0 1px 0 rgba(255,255,255,.9);
  filter: brightness(1.03);
}
.btn-rosa .sheen {
  position: absolute; 
  top: -30%; 
  left: -30%;
  width: 60%; 
  height: 160%; 
  transform: rotate(20deg);
  background: linear-gradient(90deg, rgba(255,255,255,0) 0%, rgba(255,255,255,.6) 50%, rgba(255,255,255,0) 100%);
  pointer-events: none; 
  mix-blend-mode: screen; 
  opacity: 0;
}

/* ==================== RESPONSIVE ==================== */
@media (max-width: 380px) {
  .titulo-script { font-size: 42px; }
  .hora { font-size: 23px; }
  .lugar { font-size: 17px; }
}

/* Accesibilidad */
@media (prefers-reduced-motion: reduce) {
  * { transition: none !important; animation: none !important; }
}

/* ===== Escena final (degradado + flores) ===== */
.lux-escena-final {
  position: relative;
  width: 100%;
  display: grid;
  place-items: center;
  margin-top: 0px;  
  margin-bottom: -30px;
  overflow: visible;
}

.lux-degradado {
  width: 100%;
  height: 180px;
  background: linear-gradient(
    to top,
    #f6d5e5 0%,
    rgba(246,213,229,0.85) 35%,
    rgba(246,213,229,0.35) 65%,
    rgba(246,213,229,0) 100%
  );
}

.lux-flores {
  position: absolute;
  bottom: -2px;
  left: 50%;
  transform: translateX(-50%);
  width: min(760px, 110%);
  max-width: 110%;
  pointer-events: none;
  filter: drop-shadow(0 8px 18px rgba(0,0,0,.08));
  opacity: 0.98;
}
</style>